import { render } from "./FilterMenu.vue?vue&type=template&id=06da48c2"
import script from "./FilterMenu.vue?vue&type=script&lang=js"
export * from "./FilterMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"FilterMenu.vue"]])

export default __exports__